export const buttonStyles = {
  components: {
    Button: {
      variants: {
        "no-hover": {
          _hover: {
            boxShadow: "none",
          },
        },
        "transparent-with-icon": {
          bg: "transparent",
          fontWeight: "bold",
          borderRadius: "inherit",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          _hover: {
            bg: "rgba(255, 255, 255, 0.05)",
            transform: "translateY(-1px)",
          },
          _active: {
            bg: "transparent",
            transform: "scale(0.98)",
            borderColor: "transparent",
          },
          _focus: {
            boxShadow: "none",
          },
        },
        brand: {
          bg: "linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)",
          color: "#fff",
          fontWeight: "600",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 4px 15px rgba(139, 92, 246, 0.4)",
          _hover: {
            bg: "linear-gradient(135deg, #9f75ff 0%, #7c3aed 100%)",
            boxShadow: "0 6px 25px rgba(139, 92, 246, 0.6)",
            transform: "translateY(-2px)",
          },
          _active: {
            bg: "linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%)",
            transform: "translateY(0)",
          },
          _focus: {
            boxShadow: "0 0 0 3px rgba(139, 92, 246, 0.4)",
          },
        },
        outlineWhite: {
          bg: "transparent",
          color: "#fff",
          borderColor: "rgba(255, 255, 255, 0.4)",
          borderWidth: "1px",
          transition: "all 0.2s ease-in-out",
          _hover: {
            bg: "rgba(255, 255, 255, 0.1)",
            borderColor: "rgba(255, 255, 255, 0.6)",
            transform: "translateY(-1px)",
          },
          _active: {
            bg: "rgba(255, 255, 255, 0.2)",
            transform: "scale(0.98)",
          },
          _focus: {
            boxShadow: "0 0 0 3px rgba(255, 255, 255, 0.2)",
          },
        },
        ghost: {
          bg: "transparent",
          transition: "all 0.2s ease-in-out",
          _hover: {
            bg: "rgba(139, 92, 246, 0.1)",
          },
        },
        success: {
          bg: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
          color: "#fff",
          fontWeight: "600",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 4px 15px rgba(34, 197, 94, 0.4)",
          _hover: {
            boxShadow: "0 6px 25px rgba(34, 197, 94, 0.6)",
            transform: "translateY(-2px)",
          },
          _active: {
            transform: "translateY(0)",
          },
        },
        danger: {
          bg: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
          color: "#fff",
          fontWeight: "600",
          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          boxShadow: "0 4px 15px rgba(239, 68, 68, 0.4)",
          _hover: {
            boxShadow: "0 6px 25px rgba(239, 68, 68, 0.6)",
            transform: "translateY(-2px)",
          },
          _active: {
            transform: "translateY(0)",
          },
        },
      },
      baseStyle: {
        borderRadius: "12px",
        fontWeight: "600",
        transition: "all 0.2s ease-in-out",
        _focus: {
          boxShadow: "none",
          outline: "none",
        },
        _focusVisible: {
          boxShadow: "none",
          outline: "none",
        },
        _active: {
          transform: "scale(0.98)",
          outline: "none",
        },
      },
    },
  },
};
